import { Component, HostListener, OnInit } from '@angular/core';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { drawDOM, exportPDF, Group, } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { environment } from 'src/environments/environment';
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ObservableService } from 'src/app/appServices/ObservableService/observable.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { SeriesLabels, ValueAxisLabels } from '@progress/kendo-angular-charts';
const AUTH_API = environment.teleUrl;

@Component({
  selector: 'app-rapidi-notification',
  templateUrl: './rapidi-notification.component.html',
  styleUrls: ['./rapidi-notification.component.scss'],
})
export class RapidiNotificationComponent implements OnInit {
  public lineChartPlugins = [ChartDataLabels];
  activationTimeList: any = [];
  assessmentTimeList: any = [];
  thrombolyticDecisionTimeList: any = [];
  thrombolyticAdministrationTimeList: any = [];
  getRAPIDNotificationValuesList: any = [];
  accessCase: string=`${AUTH_API}Case/Edit/`;
  showPopupOnLoad:string = `?showPopupOnLoad=true`
  totalRecords = 0;
  activationTotalRecords = 0;
  assesmentTotalRecords = 0;
  thrombolyticDecisionTotalRecords = 0;
  thrombolyticAdministrationTotalRecords = 0;
  pageNumber = 1;
  rows = 50;
  sortOrder = 'DESC';
  sortCol = '';
  filterVal = '';
  cols: any;
  selectedColumns = '';
  chartBool: boolean = false;
  basicData: any;
  RAPIDIPopupHeader:any = '';
  exportPdfLoader: boolean = false;
  loaders= {value: false}
  activitationTimeIntervalData: any ;
  activitationTimeIntervalDataOptions: any;
  dataPAPIDI: any = [];
  labelData: any = [];
  workFlowType: any = [];
  dataa:any;
  label:any;
  workFlow: any;
  showChartBool: boolean = true;
  loader: any;
  excel_chartDisabe: any;
  showProgressSpinner:boolean = false;
  Initial_Assesment: any=[];
  UId: any;
  RoleName: any;
  lazyLoadSearchBool: boolean = false;
  workFlowTypeErrorBool:boolean = false;
  WorkFlowT:any = '';
  tabIndex: any = 0;
  activeTab: any = 0;
  private subscription: Subscription[] = []; 
  seriesColors: string[] = [];
  multiAxisBarChartData: any;
  name: any;
  chartsTitle: any;
  barChartDatasets: any = [];
  barChartCategories:any = [];
  screenWidth: number = 0;
  public titleAlignment: any = {
    align: 'start'
  };
  public valueAxisLabels: ValueAxisLabels = {
    font: "bold 14px Arial, sans-serif",
    color:"#000000"
  };
  public series: any = {
    color: '#ed2078',
    colorLabel:'#ed2078',
    font: "bold 14px Arial, sans-serif"
  };
  public seriesLabels: SeriesLabels = {
    visible: true, // Note that visible defaults to false
    padding: 3,
    font: "bold 14px Arial, sans-serif",
    color:"#000000"
  };
 
  constructor(public analyzeService: AnalyzeService,private helperService: HelperService,
    private Observable:ObservableService,private messageService: MessageService) {}
  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.analyzeService._facilityPiComponent.RapidiNotificationComponent = this;
    if ((this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList != null) && (this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList != undefined)) {
      this.activationTimeList = this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList.GetACTIrapidinotification.data;
      this.assessmentTimeList = this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList.GetASTIrapidinotification.data;
      this.thrombolyticDecisionTimeList = this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList.GetTHDIrapidinotification.data;
      this.thrombolyticAdministrationTimeList = this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList.GetTHAIrapidinotification.data;

      this.activationTotalRecords = this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList.GetACTIrapidinotification.TotalEMS;
      this.assesmentTotalRecords = this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList.GetASTIrapidinotification.TotalEMS;
      this.thrombolyticDecisionTotalRecords = this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList.GetTHDIrapidinotification.TotalEMS;
      this.thrombolyticAdministrationTotalRecords = this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList.GetTHAIrapidinotification.TotalEMS;
    }
    
    if(this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj != undefined){
      this.showChartBool = this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.showChartBool;
    }
    if(this.analyzeService._facilityPiRecord.getRAPIDNotificationValuesList == undefined){
      if(this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj != undefined){
      this.analyzeService._facilityPiComponent.FacilityPIComponent.getFacilityDashboardValues();
      this.lazyLoadSearchBool = true;
      }
    }else{
      this.lazyLoadSearchBool = false;
    }
    this.workFlowTypeErrorBool = false;
    this.screenWidth = window.innerWidth;
  }
  
  @HostListener('window:resize', ['$event']) onResize(event:any) {
    this.screenWidth = window.innerWidth;
  }
  ngAfterContentInit(): void {
    if(this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj != undefined){
      if(this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.data.PatientType != ''){
        this.Observable.value$.subscribe((val) => {
          // this.showProgressSpinner = val;
        });
      }
  }
  }

  SelectedTabCall(excel_chartDisabe: any, loader: any) {
    switch (this.activeTab) {
      case 0: this.GetACTIrapidinotification(excel_chartDisabe, loader); break;
      case 1: this.GetASTIrapidinotification(excel_chartDisabe, loader); break;
      case 2: this.GetTHDIrapidinotification(excel_chartDisabe, loader); break;
      case 3: this.GetTHAIrapidinotification(excel_chartDisabe, loader); break;
    }
  }

  GetACTIrapidinotification(excel_chartDisabe: any, loader: any) {
    if(this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj != undefined){
    this.showProgressSpinner = true;
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Sort.Order = this.sortOrder
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Sort.FieldName = this.sortCol
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Take = this.rows;

    this.subscription.push(
    this.analyzeService.GetACTIrapidinotification(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj).subscribe({
      next: (res: any) => {
        if (res) { 
          this.showProgressSpinner = false;
          this.activationTimeList = res.data.data;
          this.activationTimeList.forEach((item:any)=>{
            if(item.Initial_Assesment != null){
              item.Initial_Assesment = item.Initial_Assesment.split('$');
            }else{
              item.Initial_Assesment = '';
            }
          })
          this.activationTotalRecords = res.data.Total;

          this.analyzeService.currentDateTime();
          loader.value = false;
          excel_chartDisabe.value = false
        }
        this.showChartBool = false;
      },
      error: (err: any) => { },
    })
    );
  }
  }

  GetASTIrapidinotification(excel_chartDisabe: any, loader: any) {
    if(this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj != undefined){
    this.showProgressSpinner = true;
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Sort.Order = this.sortOrder
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Sort.FieldName = this.sortCol
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Take = this.rows;
    this.subscription.push(
    this.analyzeService.GetASTIrapidinotification(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj).subscribe({
      next: (res: any) => {
        if (res) { 
          this.showProgressSpinner = false;

          this.assessmentTimeList = res.data.data;
          this.assessmentTimeList.forEach((item:any)=>{
            if(item.Initial_Assesment != null){
              item.Initial_Assesment =  item.Initial_Assesment.split('$');
            }else{
              item.Initial_Assesment = '';
            }
            
          })
          this.assesmentTotalRecords = res.data.Total;

          this.analyzeService.currentDateTime();
          loader.value = false;
          excel_chartDisabe.value = false
        }
        this.showChartBool = false;
      },
      error: (err: any) => { },
    })
    );
  }
  }

  GetTHDIrapidinotification(excel_chartDisabe: any, loader: any) {
    if(this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj != undefined){
    this.showProgressSpinner = true;
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Sort.Order = this.sortOrder
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Sort.FieldName = this.sortCol
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Take = this.rows;

    this.subscription.push(
    this.analyzeService.GetTHDIrapidinotification(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj).subscribe({
      next: (res: any) => {
        if (res) { 
          this.showProgressSpinner = false;

          this.thrombolyticDecisionTimeList = res.data.data;
          this.thrombolyticDecisionTimeList.forEach((item:any)=>{
            if(item.Initial_Assesment != null){
              item.Initial_Assesment = item.Initial_Assesment.split('$');
            }else{
              item.Initial_Assesment = '';
            }
          })
          this.thrombolyticDecisionTotalRecords = res.data.Total;

          this.analyzeService.currentDateTime();
          loader.value = false;
          excel_chartDisabe.value = false
        }
        this.showChartBool = false;
      },
      error: (err: any) => { },
    })
    );
  }
  }

  GetTHAIrapidinotification(excel_chartDisabe: any, loader: any) {
    if(this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj != undefined){
    this.showProgressSpinner = true;
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Sort.Order = this.sortOrder
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Sort.FieldName = this.sortCol
    this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Take = this.rows;

    this.subscription.push(
    this.analyzeService.GetTHAIrapidinotification(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj).subscribe({
      next: (res: any) => {
        if (res) { 
          this.showProgressSpinner = false;

          this.thrombolyticAdministrationTimeList = res.data.data;
          this.thrombolyticAdministrationTimeList.forEach((item:any)=>{
            if(item.Initial_Assesment != null){
              item.Initial_Assesment = item.Initial_Assesment.split('$');
            }else{
              item.Initial_Assesment = '';
            }
            
          })
          
          this.thrombolyticAdministrationTotalRecords = res.data.Total;

          this.analyzeService.currentDateTime();
          loader.value = false;
          excel_chartDisabe.value = false
        }
        this.showChartBool = false;
      },
      error: (err: any) => { },
    })
    );
  }
  }

  lazyLoadSchedules(event: any) {
    if (event != undefined) {
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == -1
          ? 'DESC'
          : 'ASC';
      this.sortCol =
        event.multiSortMeta == undefined
          ? 'TeleCareCase#'
          : event.multiSortMeta[0].field;
      this.filterVal =
        event.filters.global == undefined ? '' : event.filters.global.value;
      if (this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj != undefined) {
        this.loader = { 'value': true };
        this.excel_chartDisabe = { 'value': true, 'excel_show': true, 'facility_charts_Show': false, 'pi_chart_show': false };
        this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.PageNumber = this.pageNumber;
        this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Take = this.rows;
        this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.Skip = this.rows * this.pageNumber - this.rows;
        if (this.rows != 50 || this.pageNumber != 1 || event.multiSortMeta != undefined) {
          this.lazyLoadSearchBool = false;
        }
        if (this.lazyLoadSearchBool == false) {
          if (this.analyzeService._facilityPiFilterObj.RapidiNotificationDataObj.data.PatientType != '') {
            switch (this.activeTab) {
              case 0: this.GetACTIrapidinotification(this.excel_chartDisabe, this.loader); break;
              case 1: this.GetASTIrapidinotification(this.excel_chartDisabe, this.loader); break;
              case 2: this.GetTHDIrapidinotification(this.excel_chartDisabe, this.loader); break;
              case 3: this.GetTHAIrapidinotification(this.excel_chartDisabe, this.loader); break;
            }
          } else {
            if (this.workFlowTypeErrorBool == false) {
              this.messageService.add({
                key: 'save',
                severity: 'error',
                summary: 'Please ',
                detail: 'Please select WorkFlow Type first.',
              });
              this.workFlowTypeErrorBool = true;
            }
          }
        }
      }
    }
  }

  showChart(Title:any){
    this. labelData = [];
    this.dataPAPIDI = [];
    this.workFlowType = [];
    this.chartBool = true;
    
      if(Title == 'ACTIVATION TIME INTERVAL'){
        this.RAPIDIPopupHeader = 'ACTIVATION TIME INTERVAL'
        this.activationTimeList.forEach((element: any) => {
       if(element.WorkFlowType == 'EMS' && element.ActivationTimeInterval > 0){
        this.workFlow = element.WorkFlowType;
        this. workFlowType.push(this.workFlow)

        this.label = element.cas_case_number;
         this.WorkFlowT = element.WorkFlowType;
       this.label = this.WorkFlowT.concat('-').concat(this.label)
        this. labelData.push(this.label.toString())

       this.dataa = element.ActivationTimeInterval;
       this.dataPAPIDI.push(this.dataa.toString());
       }else if(element.WorkFlowType == 'Triage/Walk-In' && element.ActivationTimeInterval > 5){
        this.workFlow = element.WorkFlowType;
        this. workFlowType.push(this.workFlow)

        this.label = element.cas_case_number; 
        this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
        this. labelData.push(this.label.toString())

        this.dataa = element.ActivationTimeInterval;
        this.dataPAPIDI.push(this.dataa.toString());
       }else if(element.WorkFlowType == 'ED Onset' && element.ActivationTimeInterval > 5){
        this.workFlow = element.WorkFlowType;
        this. workFlowType.push(this.workFlow)

        this.label = element.cas_case_number;
        this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
        this. labelData.push(this.label.toString())

        this.dataa = element.ActivationTimeInterval;
        this.dataPAPIDI.push(this.dataa.toString());
       } else if(element.WorkFlowType == 'Inpatient' && element.ActivationTimeInterval > 5){
        this.workFlow = element.WorkFlowType;
        this. workFlowType.push(this.workFlow)
        
        this.label = element.cas_case_number;
        this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
        this. labelData.push(this.label.toString())

        this.dataa = element.ActivationTimeInterval;
        this.dataPAPIDI.push(this.dataa.toString());
       }

      });
      }else if(Title == 'ASSESSMENT TIME INTERVAL'){
        this.RAPIDIPopupHeader = 'ASSESSMENT TIME INTERVAL'
        this.assessmentTimeList.forEach((element: any) => {

       if(element.WorkFlowType == 'EMS' && element.AssessmentTimeInterval > 12){
        this.workFlow = element.WorkFlowType;
        this. workFlowType.push(this.workFlow)

        this.label = element.cas_case_number;
        this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
        this. labelData.push(this.label.toString())

       this.dataa = element.AssessmentTimeInterval;
       this.dataPAPIDI.push(this.dataa.toString());
       }else if(element.WorkFlowType == 'ED Onset' && element.AssessmentTimeInterval > 12){
        this.workFlow = element.WorkFlowType;
        this. workFlowType.push(this.workFlow)

        this.label = element.cas_case_number;
        this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
        this. labelData.push(this.label.toString())

        this.dataa = element.AssessmentTimeInterval;
        this.dataPAPIDI.push(this.dataa.toString());
       }else if(element.WorkFlowType == 'Triage/Walk-In' && element.AssessmentTimeInterval > 12){
        this.workFlow = element.WorkFlowType;
        this. workFlowType.push(this.workFlow)

        this.label = element.cas_case_number;
        this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
        this. labelData.push(this.label.toString())

        this.dataa = element.AssessmentTimeInterval;
        this.dataPAPIDI.push(this.dataa.toString());
       } else if(element.WorkFlowType == 'Inpatient' && element.AssessmentTimeInterval > 12){
        this.label = element.cas_case_number;
        this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
        this. labelData.push(this.label.toString())

        this.dataa = element.AssessmentTimeInterval;
        this.dataPAPIDI.push(this.dataa.toString());
       }
      })
      }else if(Title == 'THROMBOLYTIC DECISION TIME INTERVAL'){
        this.RAPIDIPopupHeader = 'THROMBOLYTIC DECISION TIME INTERVAL';
        this.thrombolyticDecisionTimeList.forEach((element: any) => {
    
         if(element.WorkFlowType == 'EMS' && element.ThrombolyticDecisionInterval > 10){
          this.label = element.cas_case_number;
          this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
          this. labelData.push(this.label.toString())

         this.dataa = element.ThrombolyticDecisionInterval;
         this.dataPAPIDI.push(this.dataa.toString());
         }else if(element.WorkFlowType == 'ED Onset' && element.ThrombolyticDecisionInterval > 10){
          this.label = element.cas_case_number;
          this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
          this. labelData.push(this.label.toString())

          this.dataa = element.ThrombolyticDecisionInterval;
          this.dataPAPIDI.push(this.dataa.toString());
         }else if(element.WorkFlowType == 'Triage/Walk-In' && element.ThrombolyticDecisionInterval > 10){
          this.label = element.cas_case_number;
          this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
          this. labelData.push(this.label.toString())

          this.dataa = element.ThrombolyticDecisionInterval;
          this.dataPAPIDI.push(this.dataa.toString());
         } else if(element.WorkFlowType == 'Inpatient' && element.ThrombolyticDecisionInterval > 10){
          this.label = element.cas_case_number;
          this.WorkFlowT = element.WorkFlowType;
          this.label = this.WorkFlowT.concat('-').concat(this.label)
          this. labelData.push(this.label.toString())

          this.dataa = element.ThrombolyticDecisionInterval;
          this.dataPAPIDI.push(this.dataa.toString());
         }
        })
      }else if(Title == 'THROMBOLYTIC ADMINISTRATION TIME INTERVAL'){
        this.RAPIDIPopupHeader = 'THROMBOLYTIC ADMINISTRATION TIME INTERVAL';
        this.thrombolyticAdministrationTimeList.forEach((element: any) => {

         if(element.WorkFlowType == 'EMS' && element.ThrombolyticAdministrationInterval > 8){
          this.label = element.cas_case_number;
          this.WorkFlowT = element.WorkFlowType;
          this.label = this.WorkFlowT.concat('-').concat(this.label)
          this. labelData.push(this.label.toString())

         this.dataa = element.ThrombolyticAdministrationInterval;
         this.dataPAPIDI.push(this.dataa.toString());
         }else if(element.WorkFlowType == 'ED Onset' && element.ThrombolyticAdministrationInterval > 8){
          this.label = element.cas_case_number;
          this.WorkFlowT= element.WorkFlowType;
          this.label = this.WorkFlowT.concat('-').concat(this.label)
          this. labelData.push(this.label.toString())

          this.dataa = element.ThrombolyticAdministrationInterval;
          this.dataPAPIDI.push(this.dataa.toString());
         }else if(element.WorkFlowType == 'Triage/Walk-In' && element.ThrombolyticAdministrationInterval > 8){
          this.label = element.cas_case_number;
          this.WorkFlowT = element.WorkFlowType;
          this.label = this.WorkFlowT.concat('-').concat(this.label)
          this. labelData.push(this.label.toString())

          this.dataa = element.ThrombolyticAdministrationInterval;
          this.dataPAPIDI.push(this.dataa.toString());
         } else if(element.WorkFlowType == 'Inpatient' && element.ThrombolyticAdministrationInterval > 8){
          this.label = element.cas_case_number;
          this.WorkFlowT = element.WorkFlowType;
        this.label = this.WorkFlowT.concat('-').concat(this.label)
          this. labelData.push(this.label.toString())

          this.dataa = element.ThrombolyticAdministrationInterval;
          this.dataPAPIDI.push(this.dataa.toString());
         }
        })
      }

  // this.functionChartData(Title,this.labelData,this.dataPAPIDI,this. workFlowType,this.activationTimeList,this.assessmentTimeList,this.thrombolyticDecisionTimeList,this.thrombolyticAdministrationTimeList)
  this.showAllFacilityDashBoardCharts(Title,this.dataPAPIDI,this.labelData)
  }

  showAllFacilityDashBoardCharts(
    Title: any,
    MeanCalculations: any,
    labelData:any
  ) {
      this.seriesColors = ['#ed2078'];
      this.name = 'Graph Outliers';
      this.chartsTitle = Title;
      this.barChartDatasets = MeanCalculations;
      this.barChartCategories = labelData;
    
  }

  functionChartData(Title:any, labelData: any, dataPAPIDI: any,workFlowType: any,activationTimeList: any,assessmentTimeList: any,thrombolyticDecisionTimeList:any,thrombolyticAdministrationTimeList:any){
    this.activitationTimeIntervalData = [];
    this.activitationTimeIntervalData = {
      labels:  labelData,
      datasets: [
        { 
          label: 'Graph Outliers',
          data:dataPAPIDI,
          fill: true,
          backgroundColor: '#E31C79',
          datalabels: {
            display: true,
            anchor: 'end',
            align: 'end',
            color: 'black',
            type1: activationTimeList,
            type2:assessmentTimeList,
            type3:thrombolyticDecisionTimeList,
            type4:thrombolyticAdministrationTimeList,
            text: Title,
            formatter: function (val: any, context: any) {
              if(context.dataset.datalabels.text == 'ACTIVATION TIME INTERVAL'){
                let a = context.dataset.datalabels.type1.find((d:any) => d.ActivationTimeInterval == val)
                return  val;
              }else  if(context.dataset.datalabels.text == 'ASSESSMENT TIME INTERVAL'){
                let a = context.dataset.datalabels.type2.find((d:any) => d.AssessmentTimeInterval == val)
                return  val;
              }else  if(context.dataset.datalabels.text == 'THROMBOLYTIC DECISION TIME INTERVAL'){
                let a = context.dataset.datalabels.type3.find((d:any) => d.ThrombolyticDecisionInterval == val)
                return  val;
              }else  if(context.dataset.datalabels.text == 'THROMBOLYTIC ADMINISTRATION TIME INTERVAL'){
                let a = context.dataset.datalabels.type4.find((d:any) => d.ThrombolyticAdministrationInterval == val)
                return  val;
              }
              return ;
           
            }
          },
        },
       
      ],
    };
  this.activitationTimeIntervalDataOptions = [];
    this.activitationTimeIntervalDataOptions = {
      responsive: true,
      plugins: {
        legend: {
          position:'right',
          labels: {
            color: 'black',
          },
        },
        title: {
          display: true,
          text: Title,
          fullsize: true,
          font: { weight: 'bold', size: 18 },
          padding: 25,
          align: 'start',
        },
        tooltip: {
          enabled: false,
        },
      },
      scales: {
        x: {
          offset: true,
          title: {
            display: true,
          },
          ticks: {
            major: {
              enabled: true,
            },
            padding: 10, // to move x-axis labels up and down
            color: 'black', // change color of x-axis labels
            font: { weight: 'bold', size: 12 },
          },
          grid: {
            color: '#ebedef',
          },
        },
        y: {
          id: 'y',
          display: true,
          title: {
            display: true,
          },
          min: 0,
        },
      },
    };
  }

  switchHeaders(tabNumber: any) {
    this.activeTab = tabNumber.index;
    this.loader = { 'value': true };
    switch (this.activeTab) {
      case 0: this.GetACTIrapidinotification(this.excel_chartDisabe, this.loader); break;
      case 1: this.GetASTIrapidinotification(this.excel_chartDisabe, this.loader); break;
      case 2: this.GetTHDIrapidinotification(this.excel_chartDisabe, this.loader); break;
      case 3: this.GetTHAIrapidinotification(this.excel_chartDisabe, this.loader); break;
    }
  }

  hideChartDiaglog(){
    this.chartBool = false;
  }
  
  exportPdf(): void {
    this.exportPdfLoader = true;
  drawDOM(document.getElementById("htmlData") as HTMLElement, {
    paperSize: "auto",
    scale: 0.8,
    landscape: true,
    margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" }

  }).then((group: Group) => {
    return exportPDF(group);
  })
  .then((dataUri) => {
    saveAs(dataUri, "Export.pdf");
    this.exportPdfLoader = false;
  });
  }

  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
     Object.getOwnPropertyNames(this)
      .filter(propName => Array.isArray((<any>this)[propName]))
      .forEach(propName => (<any>this)[propName] = []);
     
     }
}
